import { Typography, Row, Col } from 'antd';

interface ShortfallInfoProps {
  label: string;
  value: string;
  isValueRed?: boolean;
}

export const ShortfallInfo = ({ label, value, isValueRed = false }: ShortfallInfoProps): JSX.Element => {
  return (
    <Row gutter={8} justify="space-between">
      <Col>
        <Typography.Text type="secondary">{label}</Typography.Text>
      </Col>
      <Col>
        <Typography.Text type={isValueRed ? 'danger' : undefined}>{value}</Typography.Text>
      </Col>
    </Row>
  );
};
